import React from "react";
import { Typography, Button, Container, Stack } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { keyframes } from "@emotion/react";
import NavigationWrapper from "../components/layout/NavigationWrapper";
import SEO from "../components/Seo";
import Colors from "../constants/colors";
import NotFoundNy from "../assets/svgs/notFoundNy.svg";

// Definer keyframes for fade-in animasjonen
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const NotFoundPage: React.FC = () => {
  return (
    <NavigationWrapper>
      <Stack
        bgcolor={Colors.DARK_BLUE["100"]}
        sx={{
          animation: `${fadeIn} 1.5s ease-in-out`,
        }}
      >
        <Container>
          <Stack alignItems="flex-start">
            <Button
              variant="text"
              color="light"
              startIcon={<ArrowBack />}
              href="../"
            >
              Tilbake
            </Button>
          </Stack>
          <Stack
            alignItems="center"
            pr={{
              xs: "0px",
              md: "96px",
            }}
          >
            <Stack>
              <Stack
                alignItems="flex-start"
                pt="48px"
                sx={{
                  transform: "rotate(4.828deg)",
                }}
              >
                <Typography variant="textError404">
                  Denne siden forsvant i et sparetiltak.
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Stack alignItems="center">
            <Stack maxWidth="800px" width="100%" mb="96px" pt="48px">
              <NotFoundNy width="100%" height="100%" />
            </Stack>
          </Stack>
        </Container>
      </Stack>
    </NavigationWrapper>
  );
};

export default NotFoundPage;

export function Head() {
  return <SEO title="404 - Horde" description="Siden finnes ikke" />;
}
